import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * A todo item within the todo list
 */
interface TodoItemProps {
  /**
   * The title of the todo item
   */
  title: string;
  /**
   * Whether the todo item has been completed
   */
  complete: boolean;

  /**
   * The slug for the course's navigation
   */
  slug: string;
}

/**
 * The todo item within the required courses list
 */
const TodoItem = ({ title, complete, slug }: TodoItemProps) => {
  return (
    <Box display="flex" alignItems="center" marginBottom=".25em">
      {complete ? (
        <CheckCircleRoundedIcon sx={{ color: '#00c853' }} />
      ) : (
        <RadioButtonUncheckedRoundedIcon />
      )}
      <Typography
        component={Link}
        to={`/training/courses/${slug}`}
        sx={{
          fontWeight: 500,
          marginLeft: '.5em',
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default TodoItem;
